import { render, staticRenderFns } from "./talentInfo.vue?vue&type=template&id=6be459da&scoped=true"
import script from "./talentInfo.vue?vue&type=script&lang=js"
export * from "./talentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be459da",
  null
  
)

export default component.exports